import { View, StyleSheet, Pressable } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { ThemedText } from "@/components/ThemedText";
import { useTheme } from "@/hooks/useTheme";

interface ErrorBannerProps {
  message: string;
  onDismiss: () => void;
}

export function ErrorBanner({ message, onDismiss }: ErrorBannerProps) {
  const { colors } = useTheme();

  return (
    <View style={[styles.container, { backgroundColor: colors.red.background, borderColor: colors.red.border }]}>
      <MaterialCommunityIcons name="alert-circle-outline" size={18} color={colors.red.text} />
      <ThemedText style={[styles.message, { color: colors.red.text }]}>{message}</ThemedText>
      <Pressable onPress={onDismiss} style={styles.dismissButton}>
        <MaterialCommunityIcons name="close" size={16} color={colors.red.text} />
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    padding: 12,
    borderRadius: 8,
    borderWidth: 1,
    marginBottom: 12,
    gap: 8,
  },
  message: {
    flex: 1,
    fontSize: 13,
  },
  dismissButton: {
    padding: 4,
  },
});
